module.exports = __webpack_public_path__ + "img/bg.bd9afd9f.svg";